import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import "../assets/css/EditCustomer.css";
import "../assets/css/DigixLeads.css";
import "../assets/css/AddSocialaccount.css";
import axiosInstance from "../components/api/axiosInstance";
import { SOCIAL_PLATFORMS, SOCIAL_PLATFORM_VALUES } from "../constants/socialPlatforms";

const ACCOUNT_STATUSES = ["Active", "Inactive"];

function EditAccount({ accountId, onBack, onUpdate }) {
  const [formData, setFormData] = useState({
    platformName: "",
    accountName: "",
    username: "",
    password: "",
    profileUrl: "",
    businessUrl: "",
    emailUsed: "",
    contactNumber: "",
    clientId: "",
    status: "",
    notes: ""
  });

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchAccount = async () => {
      setLoading(true);
      try {
        let account = null;
        try {
          const response = await axiosInstance.get(`/social-account/${accountId}`);
          if (response.data) {
            account = response.data.Account_Id ? response.data : (response.data.data || response.data);
          }
        } catch {
          const response = await axiosInstance.get("/accounts");
          const list = Array.isArray(response?.data)
            ? response.data
            : Array.isArray(response?.data?.data)
              ? response.data.data
              : [];
          account = list.find(
            (item) => String(item.Account_Id || item.account_id) === String(accountId)
          ) || null;
        }

        if (account) {
          const sharedUrl = account.URL || account.url || "";
          const rawPlatform = account.Platform_Name || account.platform_name || "";
          const platformLower = rawPlatform.toLowerCase();
          const platformName = SOCIAL_PLATFORM_VALUES.includes(platformLower)
            ? platformLower
            : rawPlatform;
          setFormData({
            platformName,
            accountName: account.Account_Name || account.account_name || "",
            username: account.Username || account.username || "",
            password: account.Password || account.password || "",
            profileUrl: account.Profile_URL || account.profile_url || sharedUrl,
            businessUrl: account.Business_URL || account.business_url || sharedUrl,
            emailUsed: account.Email_Used || account.email_used || "",
            contactNumber: account.Contact_Number || account.contact_number || "",
            clientId: String(account.client_id ?? account.client_id ?? ""),
            status: account.Status || account.status || "",
            notes: account.Notes || account.notes || ""
          });
        }
      } catch (err) {
        console.error("Error fetching account:", err);
        alert("Failed to load account details. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchAccount();
  }, [accountId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.platformName || !formData.accountName || !formData.username) {
      alert("Please fill in required fields (Platform Name, Account Name, Username)");
      return;
    }

    // Get Updated_By from user
    let updatedBy = 1;
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const user = JSON.parse(userStr);
        updatedBy = user.user_id || user.id || 1;
      }
    } catch (err) {
      console.error("Error reading user for Updated_By:", err);
    }

    const payload = {
      Platform_Name: formData.platformName,
      Account_Name: formData.accountName,
      Username: formData.username,
      Password: formData.password || null,
      Profile_URL: formData.profileUrl || null,
      Business_URL: formData.businessUrl || null,
      URL: (formData.businessUrl || formData.profileUrl || "").trim() || null,
      Email_Used: formData.emailUsed || null,
      Contact_Number: formData.contactNumber || null,
      client_id: formData.clientId ? Number(formData.clientId) : null,
      Status: formData.status || null,
      Notes: formData.notes || null,
      Updated_By: updatedBy
    };

    setSubmitting(true);
    try {
      const response = await axiosInstance.put(`/update-social-account/${accountId}`, payload);
      
      if (response.data) {
        alert("Account updated successfully");
        // Call parent callback to refresh accounts list
        if (onUpdate) {
          onUpdate();
        }
        // Navigate back to accounts page
        if (onBack) {
          onBack();
        }
      } else {
        throw new Error("Update failed - no response data");
      }
    } catch (err) {
      console.error("Error updating account:", err);
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Failed to update account.";
      alert(msg);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="editcustomer-container">
        <div className="editcustomer-loading">Loading account details...</div>
      </div>
    );
  }

  return (
    <div className="editcustomer-container">
      <button className="back-link" onClick={onBack}>
        <FaArrowLeft /> Back 
      </button>
      <form className="editcustomer-form" onSubmit={handleSubmit}>
        <div className="form-section">
          <div className="form-grid">
            <div className="form-group">
              <label>Platform Name <span className="required">*</span></label>
              <select
                name="platformName"
                value={formData.platformName}
                onChange={handleInputChange}
                required
              >
                <option value="">Select platform</option>
                {SOCIAL_PLATFORMS.map((p) => (
                  <option key={p.value} value={p.value}>
                    {p.label}
                  </option>
                ))}
                {formData.platformName &&
                  !SOCIAL_PLATFORM_VALUES.includes(formData.platformName) && (
                    <option value={formData.platformName}>{formData.platformName}</option>
                  )}
              </select>
            </div>
            <div className="form-group">
              <label>Account Name <span className="required">*</span></label>
              <input
                type="text"
                name="accountName"
                value={formData.accountName}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Username <span className="required">*</span></label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              
              />
            </div>
            <div className="form-group">
              <label>Profile URL</label>
              <input
                type="url"
                name="profileUrl"
                value={formData.profileUrl}
                onChange={handleInputChange}
               
              />
            </div>
            <div className="form-group">
              <label>Business URL</label>
              <input
                type="url"
                name="businessUrl"
                value={formData.businessUrl}
                onChange={handleInputChange}
               
              />
            </div>
            <div className="form-group">
              <label>Email Used</label>
              <input
                type="email"
                name="emailUsed"
                value={formData.emailUsed}
                onChange={handleInputChange}
                
              />
            </div>
            <div className="form-group">
              <label>Contact Number</label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleInputChange}
               
              />
            </div>
            <div className="form-group">
              <label>Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
              >
                <option value="">Select Status</option>
                {ACCOUNT_STATUSES.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Notes</label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleInputChange}
                rows="3"
               
              />
            </div>
          </div>
        </div>

        <div className="editcustomer-actions">
          <button type="submit" className="addaccount-create-btn" disabled={submitting}>
            {submitting ? "Updating..." : "Update Account"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditAccount;
